<p class="toast-content-header"><strong>{{ content.header }}</strong></p>
@if (content.intro) {
  <p class="toast-content-intro">{{ content.intro }}</p>
}
@if (content.items?.length) {
  <ul class="toast-content-list">
    @for (item of content.items; track item) {
      <li>{{ item }}</li>
    }
  </ul>
}
